<template>
    <div>
        <section class="browse-banner-container teachers teach">
            <div class="container-fluid">
                <div class="browser-banner-img">
                    <img src="/images/content/browse-fundraisers.jpg" alt=""/>
                </div>
                <div class="browser-banner-content">
                    <!-- <h1 class="title-1">Browse Fundraisers</h1>
                    <div class="banner-block-outer">

                    </div> -->
                    <h1 class="title-1">Browse Fundraisers</h1>
                    <div class="banner-block-outer">
                        <div class="banner-block">
                            <div class="banner-blk-img">
                                <img src="/images/content/teacher.png" alt="Teacher">
                            </div>
                            <div class="banner-blk-btn">
                                <a href="#" class="solid-btn popup-btn" data-id="popup1">Fund a teacher</a>
                            </div>
                        </div>
                        <div class="banner-block">
                            <div class="banner-blk-img">
                                <img src="/images/content/school.png" alt="School">
                            </div>
                            <div class="banner-blk-btn">
                                <a href="#" class="solid-btn  popup-btn" data-id="popup2">Fund a School</a>
                            </div>
                        </div>
                        <div class="banner-block last-block">
                            <div class="banner-blk-img">
                                <img src="/images/content/district.png" alt="Disrict">
                            </div>
                            <div class="banner-blk-btn">
                                <a href="#" class="solid-btn  popup-btn" data-id="popup3">Fund a District</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Teacher Popup-->
            <div class="common-popup teacher-popup" id="popup1">
                <div class="common-popup-inner">
                    <a href="#" class="close-btn bClose"><span class="icon-close"></span></a>
                    <div>
                        <h3 class="title-3">What’s the <span>Teacher’s</span> name</h3>
                        <input class="input-field" type="text" v-model='preFilters.name' placeholder="Write Here">
                        <button class="solid-btn" @click.prevent='preFilter(0)'>
                            Find
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!--School Popup-->
            <div class="common-popup school-popup" id="popup2">
                <div class="common-popup-inner">
                    <a href="#" class="close-btn  bClose"><span class="icon-close"></span></a>
                    <div>
                        <h3 class="title-3">What’s the <span>School</span> name</h3>
                        <input class="input-field" type="text" v-model='preFilters.school' placeholder="Write Here">
                        <button class="solid-btn" @click.prevent='preFilter(1)'>Find<i class="fa fa-search"
                                                                                       aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
            <!--District Popup-->
            <div class="common-popup district-popup" id="popup3">
                <div class="common-popup-inner">
                    <a href="#" class="close-btn bClose"><span class="icon-close"></span></a>
                    <div>
                        <h3 class="title-3">What’s the <span>District</span> name</h3>
                        <input class="input-field" type="text" v-model='preFilters.district' placeholder="Write Here">
                        <button class="solid-btn" @click.prevent='preFilter(2)'>Find<i class="fa fa-search"
                                                                                       aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
        </section>

        <section class="teacher-fund-section" id="filterSection">
            <div class="fund-result-msg">
                <div class="fund-result-content" v-show="geoEnable && !loading && !!total && currentSearchedZip!==''">
                    <h4 class="title-4">We found <span>{{total}}</span> teachers near
                        <span>{{currentSearchedZip}}</span> area</h4>
                    <p class="paragraph">
                        This is not Your area? you can tweak your results using the filter button below.
                    </p>
                </div>
                <div class="fund-result-content" v-show="geoEnable && !loading && !total && currentSearchedZip!==''">
                    <h4 class="title-4">We not found teachers near <span>{{zip}}</span> area</h4>
                    <p class="paragraph">
                        This is not Your area? you can tweak your results using the filter button below.
                    </p>
                </div>
                <div class="fund-result-content" v-show="geoEnable && noZipFound">
                    <h4 class="title-4">We not found your <span>Zip Code</span></h4>
                    <p class="paragraph">
                        This is not Your area? you can tweak your results using the filter button below.
                    </p>
                </div>
                <div class="fund-result-btn">
                    <button class="solid-btn" @click="openFilter=!openFilter">Filters<i class="fa fa-filter"
                                                                                        aria-hidden="true"></i></button>
                </div>
            </div>

            <div class="fund-search-filter" :class="openFilter?' active':''">
                <h4 class="title-4">Find the classrooms ready for your help:</h4>
                <div class="filter-top">
                    <div class="eq-width">
                        <input class="input-field"
                               type="text"
                               value="{this.name}"
                               v-model="name" placeholder="Teacher name">
                        <!--v-on:blur="search(true,'from blur name')"-->
                    </div>
                    <div class="eq-width">
                        <input class="input-field"
                               type="text"
                               v-model="school" placeholder="School">
                        <!--v-on:blur="search(true,'from blur school')"-->
                    </div>
                    <div class="district-select">
                        <input class="input-field" type="text"
                               v-model="district" placeholder="District">
                        <!--v-on:blur="search(true, 'from distric')"-->
                    </div>
                    <div class="eq-width-two">
                        <input class="input-field" type="text"
                               v-model="state" placeholder="State">
                        <!--v-on:blur="search(true,'from state')"-->
                    </div>
                    <div class="eq-width-two">
                        <input class="input-field" type="text"
                               v-model="city" placeholder="City">
                        <!--v-on:blur="search(true, 'from city')"-->
                    </div>
                    <div class="bg-element">
                        <div class="eq-width-two">
                            <input class="input-field" type="text"
                                   v-model="zip" placeholder="ZIP Code">
                            <!--v-on:blur="search(true , 'from zip')"-->
                        </div>
                        <div class="label-field">
                            <span>within</span>
                        </div>
                        <div class="mile-select">
                            <div class="select-outer">
                                <el-select v-model="miles" placeholder="Radius" :disabled="zip===''">
                                    <el-option :key="5" label="5 miles" :value="5"></el-option>
                                    <el-option :key="10" label="10 miles" :value="10"></el-option>
                                    <el-option :key="15" label="15 miles" :value="15"></el-option>
                                    <el-option :key="20" label="20 miles" :value="20"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="filter-btm">
                    <div class="eq-width">
                        <div class="select-outer">
                            <el-select v-model="grade" filterable placeholder="Select Grade" :clearable="true">
                                <el-option
                                    v-for="item in grades"
                                    :key="item.key"
                                    :disabled="item.disabled"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="percent-slider-field">
                        <label for="lunch">National School Lunch Program Participants</label>
                        <div class="percentage-slider project">
                            <input type="text"
                                   class="percent"
                                   id="lunch"
                                   placeholder="0%"
                                   @click="selectInput('lunch')"
                                   v-model='lunchInput'/>
                            <div class="bar">
                                <Slider v-model="lunch"></Slider>
                            </div>
                            <!--<div class="bar" id="lunchSlider"></div>-->
                        </div>
                    </div>
                    <div class="percent-slider-field">
                        <label for="funding">Percentage of Funding</label>
                        <div class="percentage-slider project">
                            <input type="text"
                                   class="percent"
                                   id="funding"
                                   placeholder="0%"
                                   @click="selectInput('funding')"

                                   v-model="fundingInput"/>
                            <div class="bar" id="fundingSlider">
                                <Slider v-model="funding"></Slider>
                            </div>
                        </div>
                    </div>
                    <div class="filter-show-btn">
                        <button class="solid-btn" v-on:click="search(true, 'from show classroom')">Show Classrooms
                        </button>
                    </div>
                    <div class="filter-reset-btn">
                        <button class="solid-btn outline" v-on:click="reset(true)">
                            Reset<i class="fa fa-repeat" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!--Begin funds result sort bar section-->

            <section id="sortBar" class="sort-bar-container sort-filter" :class="sortBarClass? 'sortBarFixed':''">
                <div class="sort-bar-wrapper">
                    <div class="sort-bar-outer">
                        <div class="sort-bar-title">
                            <h5 class="title-5">Funds Near You</h5>
                        </div>
                        <div class="sort-select">
                            <label>Sort</label>
                            <div class="select-outer">
                                <el-select v-model="sort" placeholder="Select Sort">
                                    <!--<el-option key="donationDescending"-->
                                    <!--label="Closest to Funding"-->
                                    <!--value="donation|desc">-->
                                    <!--Closest to Funding-->
                                    <!--<span class="icon-sort desc">-->
                                    <!--</span>-->
                                    <!--</el-option>-->
                                    <el-option key="nameAscending"
                                               label="Alphabetical Asc"
                                               value="name|asc">
                                        Alphabetical Asc
                                        <span class="icon-sort asc">
                                        </span>

                                    </el-option>
                                    <el-option key="nameDescending"
                                               label="Alphabetical Desc"
                                               value="name|desc">
                                        Alphabetical Desc
                                        <span class="icon-sort desc">

                                        </span>
                                    </el-option>

                                </el-select>

                                <!--<select class="form-control select-box" id="brand">-->
                                <!--<option>Up</option>-->
                                <!--<option>Disabled</option>-->
                                <!--<option>Active/Hover</option>-->
                                <!--</select>-->
                            </div>
                        </div>
                        <div class="sort-fav-wrap">
                            <template v-if="cart!== null && Object.keys(cart.items).length < 18">
                                <a href="#" class="fav-check clicked" @click.prevent="toggleSelectAll(true)"
                                   :disabled="!fundraisers.length || !getUnselectedFundraiser().length"></a>
                                <label>
                                    Select All
                                    <poptip word-wrap width="200"
                                            content="You can select specific classrooms by clicking the heart next to their profile or click this heart to select all and add all classrooms showing in these search results to your cart">
                                        <i class="fa fa-info-circle" style="color: #d9232e" aria-hidden="true"></i>
                                    </poptip>
                                </label>
                            </template>
                            <template v-else>
                                <a href="#" class="fav-check" @click.prevent="toggleSelectAll(false)"
                                   :disabled="!fundraisers.length"></a>
                                <label>
                                    Unselect All
                                    <poptip word-wrap width="200"
                                            content="You can select specific classrooms by clicking the heart next to their profile or click this heart to select all and add all classrooms showing in these search results to your cart">
                                        <i class="fa fa-info-circle" style="color: #d9232e" aria-hidden="true"></i>
                                    </poptip>
                                </label>
                            </template>
                        </div>

                        <div class="sort-button">
                            <template v-if="cart === null || !Object.keys(cart.items).length">
                                <button class="solid-btn outline" disabled>Fund All Selected Items<i
                                    class="fa fa-chevron-right" aria-hidden="true"></i></button>
                            </template>
                            <template v-else>
                                <a :href="checkoutURL" class="solid-btn outline">
                                    Fund All Selected Items ({{Object.keys(cart.items).length}})
                                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                </a>
                            </template>
                        </div>
                    </div>
                </div>
            </section>

            <!--End funds result sort bar section-->

            <section class="project-section" tabindex="0" id="project-section" v-loading="loading">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="project-wrapper">
                                <div class="row text-center" v-show="total>1">
                                    <h6 class="title-6 total-teacher">
                                        <template v-if="!geoEnable || currentSearchedZip===''">
                                            <span class="total-number">{{totalFormatted}}</span> classrooms ready for
                                            your help:
                                        </template>
                                    </h6>
                                </div>
                                <div class="row text-center" v-show="total==1">
                                    <h6 class="title-6 total-teacher">
                                        <template v-if="!geoEnable || currentSearchedZip===''">
                                            <span class="total-number">1</span> classroom ready for your help:
                                        </template>
                                    </h6>
                                </div>
                                <div class="project-blk-outer" v-show="fundraisers.length">
                                    <div
                                        v-for="fundraiser in fundraisers"
                                        :key="fundraiser.id"
                                    >
                                        <fundraiser-project
                                            :key="fundraiser.id"
                                            v-if="!fundraiser.fundraiser_completed"
                                            :current-cart="cart"
                                            :fundraiser="fundraiser"
                                        >
                                        </fundraiser-project>
                                    </div>
                                </div>

                                <div class="project-blk-outer no-results-msg text-center" v-show="!fundraisers.length">
                                    <h4 class="title-4" v-show="!loading">We’re sorry, there were no results that fit
                                        your search criteria. If you didn’t find your teachers, try searching by
                                        school name or
                                        district. If your zip code didn’t show any teachers, try searching by
                                        state.</h4>
                                    <p v-show="!loading" style="text-align: center">
                                        <button class="solid-btn" style="line-height: 30px; width: 480px; height: 60px;" @click="goToAddTeacher">Want to send Supply Boxes to a teacher you know?<br/>
                                            Click here to fund their gift
                                        </button>
                                    </p>
                                </div>

                                <!--Begin pagination-->
                                <div class="navigation-block" v-show="fundraisers.length > 0"
                                     style="text-align: center">
                                    <div class="nav-previous" style="float: left;">
                                        <button v-on:click="previous()"
                                                :disabled="page == 1"
                                                class="solid-btn outline icon-left">
                                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                                            Previous page
                                        </button>
                                    </div>
                                    <el-pagination layout="slot,pager"
                                                   :current-page.sync='page'
                                                   :page-size="perPage"
                                                   :page-sizes="[18]"
                                                   @current-change="changePage"
                                                   :page-count="total_pages"
                                                   :total="total">
                                        <!--<span class="el-pagination__total"><strong>{{((page - 1) * perPage) + count}} of {{total}}</strong></span>-->
                                    </el-pagination>
                                    <div class="nav-next" style="float: right">
                                        <button v-on:click="next()"
                                                :disabled="page == total_pages"
                                                class="solid-btn outline">
                                            Next page<i class="fa fa-chevron-right" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                                <!--End pagination-->
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </section>
    </div>
</template>

<script>
export default {
  mounted () {
    const vm = this
    this.searchRoute = App.globalData.routes.teacher_search
    
    if (window.localStorage.getItem('cartId') !== null) {
      this.getCart()
    }

    if (this.populateFromQueryString()) {
      this.search()
    } else if (window.sessionStorage.searched) {
      this.getSearchedParams()
    } else {
      this.getGeolocation()
    }

    kinfEvents.$on('CartCreated', ev => {
      this.cart = {
        id: ev,
        items: {}
      }
    })

    kinfEvents.$on('newCartItem', ev => {
      this.cart.items[ev.fundraiser_slug] = ev
      this.$forceUpdate()
      kinfEvents.$emit('updateHearts', true)
    })

    kinfEvents.$on('cartItemRemoved', ev => {
      delete this.cart.items[ev]
      this.$forceUpdate()
      kinfEvents.$emit('updateHearts', true)
    })
  },
  data () {
    return {
      fundraisers: [], // fundraisers filter results
      searchRoute: '',

      // start filter parameters
      name: '',
      school: '',
      district: '',
      state: '',
      city: '',
      zip: '',
      grade: '',
      miles: 5,
      lunch: 0,
      funding: 0,
      // ends filter parameters

      lunchInput: '0%',
      fundingInput: '',

      // metadata results and pagination
      sort: 'name|asc',
      total: 0,
      total_pages: 0,
      page: 1,
      perPage: 18,
      count: 0,
      lastPage: 1,

      // configurations flags
      loading: false,
      openFilter: false,
      geoEnable: false,
      currentSearchedZip: '',
      noZipFound: false,
      cart: null,

      enabledFilter: {
        grades: []
      },

      preFilters: {
        district: '',
        school: '',
        name: ''
      },

      topScrollPosition: 0,
      sortBarClass: false
    }
  },
  watch: {
    zip (newVal, oldVal) {
      if (newVal === '') {
        this.miles = 5
      } else {
        this.noZipFound = false
      }
    },
    funding (newVal) {
      this.fundingInput = newVal === '' ? '' : newVal + '%'
    },
    lunch (newVal) {
      this.lunchInput = newVal === '' ? '' : newVal + '%'
    },
    sort () {
      this.search(true)
    },
    fundingInput (newVal) {
      this.validatePercentage('funding')
    },
    lunchInput (newVal) {
      this.validatePercentage('lunch')
    }

  },
  computed: {
    totalFormatted () {
      const formarter = new Intl.NumberFormat('en-US', { decimal: '.', group: ',' })
      return formarter.format(this.total)
    },
    grades () {
      return window.App.globalData.grades.map(grade => {
        const disabled = this.enabledFilter.grades.indexOf(grade.slug) === -1
        return {
          label: grade.name,
          value: grade.slug,
          key: grade.slug,
          disabled
        }
      })
    },
    filterParams () {
      return {
        name: this.name.trim() !== '' ? this.name : null,
        school: this.school.trim() !== '' ? this.school : null,
        district: this.district.trim() !== '' ? this.district : null,
        state: this.state.trim() !== '' ? this.state : null,
        city: this.city.trim() !== '' ? this.city : null,
        zip: this.zip !== '' ? this.zip : null,
        miles: this.zip !== '' ? this.miles : null,
        grade: this.grade !== '' ? this.grade : null,
        lunch: this.lunch !== '' ? this.lunch : null,
        funding: this.funding !== '' ? this.funding : null,
        page: this.page,
        sort: this.sort !== '' ? this.sort : null
      }
    },
    buildQueryString () {
      const query = location.pathname + '?'
      const params = []
      for (const x in this.filterParams) {
        if (this.filterParams[x]) {
          params.push(encodeURI(x) + '=' + encodeURI(this.filterParams[x]))
        }
      }
      const paramString = params.join('&')
      return query + paramString
    },
    checkoutURL () {
      return window.App.globalData.routes.checkout_page
    },
    selectAllClass () {
      if (this.cart === null) {
        return 'fav-check'
      }
      ;
      let oneNotSelected = false
      this.fundraisers.forEach(fundraiser => {
        if (this.cart.items[fundraiser.fundraiser_slug] === undefined) {
          oneNotSelected = true
        }
      })
      return !oneNotSelected ? 'fav-check clicked' : 'fav-check'
    },
    selectAll () {
      if (this.cart === null) {
        return true
      }

      return Object.keys(this.cart.items).length < 18
    }
  },
  methods: {
    previous () {
      if (this.page > 0) {
        this.page--
        this.search(false, 'search from previous page')
        window.$(window).scrollTop(window.$('.teacher-fund-section').offset().top)
      }
    },
    next () {
      if (this.page < this.total_pages) {
        this.page++
        this.search(false, 'search from nex page')
        window.$(window).scrollTop(window.$('.teacher-fund-section').offset().top)
      }
    },
    changePage (ev) {
      // console.log(ev);
      this.page = ev
      this.search(false, 'changePage')
    },
    setSearchedParams (params) {
      window.sessionStorage.setItem('searched', JSON.stringify(params))
    },
    search (resetPage, triggedFrom) {
      this.loading = true
      this.page = resetPage ? 1 : this.page

      // console.log(this.filterParams)

      window.axios.get(this.searchRoute, {
        params: this.filterParams
      }).then((response) => {
        this.fundraisers = response.data.data.data
        this.enabledFilter.grades = response.data.data.fiterAvailables.grade !== undefined
          ? response.data.data.fiterAvailables.grade
          : []

        this.lastPage = parseInt(this.page)
        this.page = response.data.data.pagination.current_page
        this.total = response.data.data.pagination.total
        if (!this.total) {
          this.openFilter = true
        }
        this.currentSearchedZip = this.zip
        this.count = response.data.data.pagination.count
        this.total_pages = response.data.data.pagination.total_pages
        this.loading = false

        this.$nextTick().then(() => {
          this.matchHeights()
          window.history.replaceState(null, 'Show Classrooms', this.buildQueryString)
          this.setSearchedParams(this.filterParams)
        })
        this.$forceUpdate()
      }).catch(e => {
        this.$notify({
          title: 'Error',
          message: 'Internal error, try later',
          type: 'error'
        })
        this.loading = false
        if (this.page !== 1) {
          this.changePage(this.lastPage)
        }
      })
    },
    getSearchedParams () {
      if (window.sessionStorage.getItem('searched') === null) {
        return
      }
      const searchedValues = JSON.parse(window.sessionStorage.getItem('searched'))
      for (const x in searchedValues) {
        if (x !== 'miles') {
          this.$set(this, x, searchedValues[x] === null ? '' : searchedValues[x])
        } else {
          this.$set(this, x, searchedValues[x] === null ? 5 : searchedValues[x])
        }
      }

      this.search(false, 'getSearchedParamsMethod')
    },
    reset (search) {
      // console.log('reset',search);
      sessionStorage.clear()
      this.name = ''
      this.school = ''
      this.district = ''
      this.state = ''
      this.city = ''
      this.zip = ''
      this.lunch = 0
      this.funding = 0
      this.miles = 5
      this.grade = ''
      this.lunchInput = ''
      this.fundingInput = ''
      this.sort = 'name|asc'
      this.noZipFound = false

      if (search) {
        this.search(false, 'search from ' +
                        'reset')
      }
    },
    populateFromQueryString () {
      const params = document.location.search.replace('?', '').split('&').map(item => {
        const keyValue = item.split('=')
        if (keyValue[0] !== '') {
          return { key: decodeURI(keyValue[0]), value: decodeURI(keyValue[1]) }
        }
        return null
      })

      if (params[0] === null) {
        return false
      }

      params.forEach(param => {
        const value = isNaN(param.value) ? param.value : parseInt(param.value)
        this.$set(this, param.key, value)
      })

      return true
    },
    matchHeights () {
      jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner h5.title-5').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      })

      jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner p.paragraph').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      })

      jQuery('.project-section .project-blk-outer .project-block .project-content .project-content-inner').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      })

      jQuery('.eq-height').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      })
    },
    validatePercentage (input) {
      if (input == 'funding') {
        const value = this.fundingInput.replace('%', '').replace(' ', '')
        const number = parseInt(value)
        if (!isNaN(number) && number >= 0 && number <= 100) {
          this.fundingInput = number + '%'
          this.funding = number
        } else {
          this.fundingInput = ''
          this.funding = 0
        }
      } else {
        const value = this.lunchInput.replace('%', '').replace(' ', '')
        const number = parseInt(value)
        if (!isNaN(number) && number >= 0 && number <= 100) {
          this.lunchInput = number + '%'
          this.lunch = number
        } else {
          this.lunchInput = ''
          this.lunch = 0
        }
      }
    },
    preFilter (type) {
      const types = ['name', 'school', 'district']
      this.reset(false)
      this.openFilter = true
      this[types[type]] = this.preFilters[types[type]]
      this.search(true, 'search from prefilter')
      $('#popup' + (type + 1)).bPopup().close()
      $('html, body').animate({
        scrollTop: $('#filterSection').offset().top
      }, 1000)
      this.preFilters[types[type]] = ''
    },
    getCart (id, updateHearts) {
      const cartId = id === undefined ? window.localStorage.getItem('cartId') : id
      const cartRoute = window.App.globalData.routes.show_cart.replace('ID', cartId)
      axios.get(cartRoute).then(response => {
        this.cart = response.data
        if (updateHearts) {
          kinfEvents.$emit('updateHearts', true)
        }
      }).catch(e => {
        console.log(e.response)
      })
    },
    getGeolocation () {
      const vm = this
      navigator.geolocation.getCurrentPosition(vm.getZip, vm.setPermissionDenied)
    },
    getZip (position) {
      this.geoEnable = true
      const route = window.App.globalData.routes.geocode
      axios.get(route, {
        params: {
          lat: position.coords.latitude,
          lon: position.coords.longitude
        }
      }).then(response => {
        if (response.data.data.zipcode !== '') {
          this.reset(false)
          this.zip = response.data.data.zipcode
          this.miles = 10
          this.search(true)
        } else {
          if (this.zip === '') {
            this.noZipFound = true
          }
          this.openFilter = true
        }
      }).catch(e => console.log(e))
      // console.log(position);
    },
    setPermissionDenied (error) {
      console.log(error)
      this.geoEnable = false
      this.search(true)
    },
    toggleSelectAll (selectAll) {
      this.loading = true
      if (this.cart === null) {
        this.createCart()
        return
      }

      let route = null
      let payload = null

      // console.log(selectAll);

      if (selectAll) {
        payload = this.getUnselectedFundraiser()
        route = window.App.globalData.routes.add_items_to_cart.replace('ID', this.cart.id)
        const current_items = Object.keys(this.cart.items).length
        const newItems = payload.length
        if (current_items + newItems > 18) {
          const remaining_space = 18 - current_items
          payload.length = remaining_space
        }

        // kinfEvents.$emit('selectAll');
      } else {
        route = window.App.globalData.routes.remove_items_from_cart.replace('ID', this.cart.id)
        // kinfEvents.$emit('unselectAll');
      }
      // console.log(payload);
      axios.post(route, { items: payload }).then(response => {
        this.$notify({
          title: 'Success',
          message: response.data.response.message,
          type: 'success'
        })

        if (selectAll) {
          const items = response.data.data.items

          items.forEach(item => {
            this.cart.items[item.fundraiser_slug] = item
          })
        } else {
          this.cart.items = {}
        }

        kinfEvents.$emit('updateHearts', true)

        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
        this.$notify({
          title: 'Error',
          message: e.response.data.response.message,
          type: 'error'
        })
        this.getCart(this.cart.id, true)
      })
    },
    createCart () {
      const createRoute = window.App.globalData.routes.create_cart
      axios.post(createRoute).then(response => {
        // this.getCart(response.data.data.cart_id);
        this.cart = {
          id: response.data.data.cart_id,
          items: {}
        }
        kinfEvents.$emit('CartCreatedFromFilter', response.data.data.cart_id)
        window.localStorage.setItem('cartId', response.data.data.cart_id)
        this.toggleSelectAll(true)
      }).catch(e => {
        console.log(e)
        this.loading = false
        this.$notify({
          title: 'Error',
          message: e.response.data.response.message,
          type: 'error'
        })
      })
    },
    getSelectedFundraisers () {
      const result = this.fundraisers.map(fundraiser => {
        return fundraiser.fundraiser_id
      })
      return result
    },
    getUnselectedFundraiser () {
      const result = this.fundraisers.map(fundraiser => {
        return {
          fundraiser_slug: fundraiser.fundraiser_slug,
          id: fundraiser.fundraiser_id,
          amount: this.getMinAmount(fundraiser.fundraiser_raised_amount),
          item: {
            name: fundraiser.name,
            grade: fundraiser.grade_taught,
            state: fundraiser.state_name,
            school: fundraiser.school,
            district: fundraiser.district,
            goal_amount: (App.goal_amount / 100).toFixed(2),
            fundraiser_id: fundraiser.id,
            raised_amount: fundraiser.fundraiser_raised_amount,
            new_teacher_id: null,
            fundraiser_slug: fundraiser.fundraiser_slug,
            current_donation: this.getMinAmount(fundraiser.fundraiser_raised_amount)
          }
        }
      })

      const noCompletedFundrasierResult = []
      result.forEach(fundraiser => {
        if (fundraiser.item.raised_amount !== 289) {
          noCompletedFundrasierResult.push(fundraiser)
        }
      })

      if (this.cart === null || !Object.keys(this.cart.items).length) {
        // console.log("Cart null o no items",noCompletedFundrasierResult);
        return noCompletedFundrasierResult
      }

      const filteredResultAlreadyInCart = []
      noCompletedFundrasierResult.forEach(fundraiser => {
        if (this.cart.items[fundraiser.fundraiser_slug] === undefined) {
          filteredResultAlreadyInCart.push(fundraiser)
        }
      })

      return filteredResultAlreadyInCart
    },
    getMinAmount (raisedAmount) {
      let minAmount = 0
      const moneyToComplete = 289 - raisedAmount
      const amounts = [moneyToComplete, 25, 50, 100]
      amounts.filter((value) => {
        // console.log(value,moneyToComplete);
        if (value <= moneyToComplete) {
          minAmount = value
        }
      })
      minAmount = minAmount < 1 ? 1 : minAmount
      return minAmount
    },
    goToAddTeacher () {
      window.sessionStorage.setItem('openAddTeacher', 'true')
      location.href = window.App.globalData.routes.checkout_page
    },
    selectInput (input) {
      $('#' + input).select()
    }
  }
}
</script>

<style>
    .project-blk-outer {
        padding: 0px 0 20px 0;
        font-size: 1.5em;
    }

    .project-blk-outer.no-results-msg {
        color: #4a4a4a;
        padding: 120px 0;
    }

    .project-blk-outer.no-results-msg p {
        color: #4a4a4a;
        font-family: 'Rubik-Regular';
    }

    .el-pager li.number {
        font-size: 18px !important;
        color: #4a4a4a !important;
        font-family: "Rubik-Regular" !important;
    }

    .el-pager li.active {
        color: #fb202d !important;
    }

    .total-teacher {
        margin-top: 26px;
        font-family: 'RobotoSlab-Regular';
        color: #4a4a4a !important;
        font-size: 26px;
    }

    .total-number {
        color: #0099FF;
        font-family: 'RobotoSlab-Regular';
        font-size: 26px;
    }

    .el-select {
        width: 100%;
        border: 2px solid #e2e7ee;
        border-radius: 10px;
        padding: 12px;
        font-family: "Rubik-Regular";
        font-size: 18px;
        color: #98a4bb;
        background: white;
        height: 55px !important;
    }

    .el-select.red-hover {
        border-color: #fb202d !important;
    }

    .el-select.red-hover {
        border-color: #fb202d !important;
    }

    .el-input__inner {
        border: 0px !important;
        margin-top: -5px !important;
        font-family: "Rubik-Regular" !important;
        font-size: 18px !important;
        padding: 0 !important;
        color: #98a4bb !important;
    }

    .sbHolder.red-hover {
        border-color: #fb202d !important;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    .el-select-dropdown {
        border: 2px solid #c8d1d9 !important;
        border-radius: 10px;
    }

    .el-select-dropdown:before {
        top: -11px;
        left: 50%;
        content: "";
        background: url(/images/select-arrow.png?a52eb7dcd2a9d932dc3246a294fe0dd2) no-repeat left;
        width: 18px;
        height: 11px;
        position: absolute;
        z-index: 999;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .el-select-dropdown__item {
        outline: none;
        padding: 15px 30px 12px;
        font-size: 18px;
        line-height: 23px;
        color: #4a4a4a;
        text-decoration: none;
        font-family: "Rubik-Regular";
        border-top: 1px solid #e2e7ee !important;
        height: auto !important;
    }

    .el-select-dropdown__item.is-disabled:hover {
        color: #c0c4cc;

    }

    .el-select-dropdown__list {
        padding: 0 !important;
    }

    .el-select {
        padding: 0 !important;
    }

    .el-input {
        top: 10px;
        padding-left: 10px;
    }

    .el-input.is-disabled .el-input__inner {
        background-color: white !important;
    }

    .el-input__inner {

    }

    .el-select-dropdown__item:first-child {
        border-top: 0px;
        border-radius: 10px 10px 0px 0px;
    }

    .el-select-dropdown__item:last-child {
        border-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    .el-select-dropdown__item:hover {
        background: #d9232e;
        color: #fff;
    }

    .el-select-dropdown__item.hover {
        background: #d9232e;
        color: #fff;
    }

    .el-select-dropdown__item.selected {
        background: #d9232e;
        color: #fff;
    }

    .popper__arrow {
        display: none !important;
    }

    .sortBarFixed {
        position: fixed;
        background: white;
        top: 0;
        z-index: 10;
    }

    .bg-element {
        padding: 10px;
        position: relative;
        top: -10px;
        border-radius: 10px;
        background: #e2dddd;
        display: flex;
    }

    .bg-element .eq-width-two,
    .bg-element .mile-select {
        width: 40% !important;
    }

    @media only screen and (max-width: 991px) and (min-width: 768px) {
        .bg-element {
            padding-bottom: 0px;
        }

        .bg-element .eq-width-two,
        .bg-element .mile-select {
            width: 50% !important;
        }
    }

    .bg-element .label-field {
        width: 14% !important;
    }

    @media (max-width: 992px) {
        .bg-element {
            top: 0;
        }
    }

    @media (max-width: 767px) {
        .bg-element {
            display: block;
            float: left;
            width: 100%;
        }

        .bg-element .eq-width-two,
        .bg-element .mile-select {
            width: 100% !important;;
        }

        .bg-element .label-field {
            width: 100% !important;
        }
    }

    .icon-sort {
        position: absolute;
        width: 17px;
        height: 20px;
        right: 10px;
        top: 17px;
    }

    .icon-sort:before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
    }

    .icon-sort.asc:before {
        background-size: 100%;
        background-repeat: no-repeat;
        background-image: url('/images/content/icon-asc.svg')
    }

    .icon-sort.desc:before {
        background-size: 100%;
        background-repeat: no-repeat;
        background-image: url('/images/content/icon-des.svg')
    }

    .el-select-dropdown__item.hover .icon-sort.asc:before {
        background-image: url('/images/content/icon-asc-w.svg')
    }

    .el-select-dropdown__item.selected .icon-sort.asc:before {
        background-image: url('/images/content/icon-asc-w.svg')
    }

    .el-select-dropdown__item.hover .icon-sort.desc:before {
        background-image: url('/images/content/icon-des-w.svg')
    }

    .el-select-dropdown__item.selected .icon-sort.desc:before {
        background-image: url('/images/content/icon-des-w.svg')
    }

    .ivu-slider {
        height: 10px;
        margin-top: -16px;
    }
    .ivu-slider-wrap{
        height: 10px;
        background-color: white;
    }
    .ivu-slider-bar{
        background-color:#49ceb0;
        height: 10px;
    }

    .ivu-slider-button{
        top: -6px;
        width: 15px;
        height: 22px;
        border: 0;
        border-radius: 0 4px 4px 4px;
        background: #d9232e url(/images/range-slider-icon.png?a9d4991…) 50% 50% no-repeat !important;
        cursor: pointer;
    }
    .sort-filter .select-outer .el-select{
        padding-right: 22px!important;
    }
    .sort-filter .select-outer .el-input__suffix{
        right: -22px;
    }
    .sort-filter .sort-select{
        margin-right: 10px;
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/index/FundraisersFilter.vue